// Range string to status array
const getSchedule = (schedules) => {
  const initSchedule = new Array(7)
  const botSchedule = parseSchedules(initSchedule, schedules[0], 1)
  const assistantSchedule = parseSchedules(botSchedule, schedules[1], 2)
  const smartChatSchedule = parseSchedules(assistantSchedule, schedules[2], 3)
  return smartChatSchedule
}

const getStatus = (index, newInitSchedule, schedule, status) => {
  const days = ['monday', 'tuesday', 'wednesday',  'thursday', 'friday',  'saturday', 'sunday']
  schedule[days[index]].ranges.forEach(range => {
    const start = range.start.substring(0,2)
    const end = range.end.substring(0,2)
    const endM = range.end.substring(3,5)
    const to = Number(endM) > 0 ? Number(end) + 1 : Number(end)
    for (let i = Number(start); i < to; i++) {
      newInitSchedule[index].ranges[i] = status
    }
  })
  return newInitSchedule[index].ranges
}

const parseSchedules = (initSchedule, schedule, status) => {
  const newInitSchedule = initSchedule

  if (status === 1) {
    for (var i = 0; i < 7; i++) {
      newInitSchedule[i] = {
        label: dayLabels(i),
        ranges: new Array(24).fill(0)
      }
    }
  }

  for (let index = 0; index < 7; index++) {
    newInitSchedule[index].ranges = getStatus(index, newInitSchedule, schedule, status)
  }

  return newInitSchedule
}

// Status array to range string
const setSchedule = (schedule) => {
  let faqConsoleSchedule = {}
  let virtualAssistantSchedule = {}
  let smartChatSchedule = {}
  schedule.forEach((day, dayIndex) => {
    const rangesForDay = parseDayRanges(day.ranges)
    faqConsoleSchedule[dayLabels(dayIndex)] = {
      isActive: rangesForDay[0].length > 0,
      ranges: rangesForDay[0]
    }
    virtualAssistantSchedule[dayLabels(dayIndex)] = {
      isActive: rangesForDay[1].length > 0,
      ranges: rangesForDay[1]
    }
    smartChatSchedule[dayLabels(dayIndex)] = {
      isActive: rangesForDay[2].length > 0,
      ranges: rangesForDay[2]
    }
  })
  return [faqConsoleSchedule, virtualAssistantSchedule, smartChatSchedule]
}

const parseDayRanges = (day) => {
  let faqConsoleRanges = getRanges(day, 1)
  let virtualAssistantRanges = getRanges(day, 2)
  let smartChatRanges = getRanges(day, 3)

  return [faqConsoleRanges, virtualAssistantRanges, smartChatRanges]
}

const dayLabels = (dayIndex) => {
  return ["monday","tuesday","wednesday","thursday","friday","saturday","sunday"][dayIndex] || ''
}

const getRanges = (ranges, status) => {
  let start = 0
  let end = 0
  let foundRanges = []
  ranges.forEach((range, rangeIndex) => {
    let rangeCount = 0
    if (range === status && rangeIndex >= end) {
      start = rangeIndex
      rangeCount = rangeIndex
      while (ranges[rangeCount] === status) {
        rangeCount++
        end = rangeCount
      }
      foundRanges.push({ start: start < 10 ? `0${start}:00` : `${start}:00`,
        end: end < 10 ? `0${end}:00` : end === 24 ? `${end - 1}:59` : `${end}:00` })
    }
  })
  return foundRanges
}

export {
  getSchedule,
  setSchedule
}